import React from 'react'
import './notFound.css'

const NotFound = () => {
  return (
    <div className="notFound">
      <div className="container">
        <h1>"Does Not Exist"</h1>
        <strong>The page you are looking for does not exist</strong>
      </div>
    </div>
  )
}

export default NotFound
